/**
 * Phase F.1b-iv-a (GEN-2998 sub-task) — pure tri-state mappers between
 * the canonical `Comparator.secondaryConsent.includeIncidentalFindings`
 * boolean-or-null shape and the legacy
 * `IncidentalFindingsSelection = 'opt-in' | 'opt-out' | null` string
 * tri-state consumed by the comparator consent UI (the incidental-findings
 * section of `<ComparatorModal>` / `<ComparatorParentConsentSections>`).
 *
 * Mapping rule (single source of truth — matches the comment on
 * `CanonicalParentInfo.includeIncidentalFindings`):
 *
 *     true   ↔ 'opt-in'
 *     false  ↔ 'opt-out'
 *     null   ↔ null      (not chosen)
 *
 * `undefined` is treated as `null` on the way in so callers do not
 * have to normalise. Unknown strings round-trip to `null` defensively
 * so that a malformed payload cannot crash the modal.
 *
 * NY sample retention and research-contact consent are direct
 * `boolean | null | undefined` passthroughs and do not need a mapper.
 */

import type { IncidentalFindingsSelection } from '@/types/RequisitionFormTypes'

export function incidentalCanonicalToSelection(value: boolean | null | undefined): IncidentalFindingsSelection {
  if (value === true) return 'opt-in'
  if (value === false) return 'opt-out'
  return null
}

export function incidentalSelectionToCanonical(
  selection: IncidentalFindingsSelection | string | null | undefined
): boolean | null {
  if (selection === 'opt-in') return true
  if (selection === 'opt-out') return false
  return null
}
